import { FC } from "react";

import Box from "@mui/material/Box";
import { SxProps, Theme } from "@mui/material/styles";

import styles from "./styles";

interface BackgroundAssetProps {
  width: number;
  height: number;
  top?: string | number;
  bottom?: number;
  left?: string | number;
  right?: number;
  image: string;
  zIndex?: number;
  translateX?: string;
  rotate?: number;
  sx?: SxProps<Theme>;
}

const BackgroundAsset: FC<BackgroundAssetProps> = ({
  width,
  height,
  top,
  bottom,
  left,
  right,
  image,
  zIndex = -1,
  translateX = "0%",
  rotate = 0,
  sx = [],
}) => {
  return (
    <Box
      width={width}
      height={height}
      sx={[
        {
          backgroundImage: `url(${image})`,
          top,
          bottom,
          left,
          right,
          zIndex,
          transform: `translate(${translateX},0%) rotate(${rotate}deg);`,
        },
        styles.backgroundAsset,
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    />
  );
};

export default BackgroundAsset;
